export default __webpack_public_path__ + "static/media/icn-avg-elevation.92e1a05a.svg";